var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5 mb-5"},[_c('iframe',{attrs:{"src":"https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=mmkgroup.zendesk.com","width":"90%","height":"600px","frameborder":"0"}})])
}]

export { render, staticRenderFns }